import React, { FC } from 'react'
import {
  FlexContainer,
  elFlex1,
  elHFull,
  Text2XL,
  TextBase,
  Button,
  ButtonGroup,
  elMt8,
  elMy5,
  elFlexAlignSelfCenter,
} from '@reapit/elements'
import { ErrorBoundary } from '@reapitform/utils'
import { cx } from '@linaria/core'
import { DialogWrapper, BrandLogo, elWFit } from '@reapitform/common-ui'
import { useFormDocument } from '../view/layout/tenant-app-layout'

export interface IDialogHelp {
  className?: string
  isModalOpen: boolean
  handlerModalClose: () => void
}

export const DialogHelp: FC<IDialogHelp> = ({ className, handlerModalClose, isModalOpen }) => {
  const formDocumentData = useFormDocument()

  return (
    <ErrorBoundary>
      <DialogWrapper hasFullScreen {...{ className, handlerModalClose, isModalOpen }}>
        <FlexContainer isFlexColumn className={cx(elHFull, elFlex1)}>
          <BrandLogo src={formDocumentData?.agentLogoUrl || '/pwa-152x152.png'} />
          <Text2XL hasBoldText hasMargin tag="h2" hasCenteredText>
            We’re here to help
          </Text2XL>
          <TextBase className={cx(elMy5)} hasRegularText hasCenteredText>
            Contact us anytime and we’ll guide you through the process.
          </TextBase>
          <TextBase hasCenteredText hasBoldText>
            {formDocumentData?.agencyName}
          </TextBase>
          <a
            className={cx(elWFit, elFlexAlignSelfCenter)}
            href={formDocumentData?.agencyDisplayContactNumber && `tel: ${formDocumentData.agencyDisplayContactNumber}`}
          >
            <TextBase hasCenteredText tag="span" intent="primary">
              {formDocumentData?.agencyDisplayContactNumber}
            </TextBase>
          </a>
          <ButtonGroup alignment="center" className={elMt8}>
            <Button onClick={handlerModalClose} intent="primary">
              Got it, thanks!
            </Button>
          </ButtonGroup>
        </FlexContainer>
      </DialogWrapper>
    </ErrorBoundary>
  )
}
